module.exports = __webpack_public_path__ + "img/bolket-logo_positive-color_signature.afff176f.svg";